import { FormGroup } from "@angular/forms";
import { PersonaService } from "../../core/http/apiPersona/persona.service";
import { Component, Input, OnInit } from "@angular/core";
import { catchError, debounceTime, Subject } from "rxjs";
export interface IFormFieldConfig {
  type: string;
  name: string;
  formControlName: string;
  placeholder: string;
  validation?: string;
  labelData?: ILabelData;
  options?: any[];
}

interface ILabelData {
  title: string;
}

@Component({
  selector: 'app-input-google',
  templateUrl: './input-google.component.html',
  styleUrls: ['./input-google.component.scss'],
})
export class InputGoogleComponent implements OnInit {
  @Input() formFieldConfig!: IFormFieldConfig;
  @Input() formGroup!: FormGroup;
  @Input() fieldsArr!: IFormFieldConfig[];

  isOptionsVisible: boolean = false;

  debouncer: Subject<string> = new Subject();
  validationRegex: RegExp = new RegExp(/^[a-zA-Z0-9]+/);

  placeInsertedByUser!: string;

  constructor(private personaService: PersonaService) { }

  ngOnInit(): void {
    this.startDebouncer();

  const direccionControl = this.formGroup.get(this.formFieldConfig.formControlName);
  if (direccionControl) {
    this.placeInsertedByUser = direccionControl.value || '';

    direccionControl.valueChanges.subscribe(value => {
      this.placeInsertedByUser = value;
    });
  }


  }

  fieldIsValid(form: FormGroup, field: string) {
    return form.controls[field].errors && form.controls[field].touched;
  }

  startDebouncer() {
    this.debouncer
      .pipe(debounceTime(1000))
      .pipe(
        catchError((error: any) => {
          return [];
        })
      )
      .subscribe((inputText: string) => {
        this.validationRegex.test(this.placeInsertedByUser)
          ? this.getGoogleSuggestionsPlaces(this.placeInsertedByUser)
          : this.formGroup.controls[this.formFieldConfig.name].setErrors({
            required: true,
          });
      });
  }

  getGoogleSuggestionsPlaces(fieldData: string) {
    this.isOptionsVisible = false;
    this.formFieldConfig.options = [];

    this.personaService
      .getAddressAutocompleteData(fieldData)
      .subscribe((res) => {
        const googleAddressSuggestions = res.data.predictions;

        googleAddressSuggestions.length > 0
          ? ((this.formFieldConfig.options = res.data.predictions),
            (this.isOptionsVisible = true))
          : false;
      });
  }

  keyPress() {
    this.debouncer.next(this.placeInsertedByUser);
  }

  onOptionSelected(option: any) {
    this.isOptionsVisible = false;
    this.placeInsertedByUser = option.description;
    this.getGoogleAddressComponents(option, this.formGroup);
  }

  getGoogleAddressComponents(optionSelected: any, form: FormGroup) {
    this.personaService
      .getAddressAutocompleteDataDetail(optionSelected.place_id)
      .subscribe((res) => {
        this.setValueOnField('direccion', optionSelected.description, form);
        const googleAddressComponents = res.data.result.address_components;
        this.setAddressDataOnForm(googleAddressComponents, form);
      });
  }

  setAddressDataOnForm(addressData: any[], form: FormGroup) {
    let streetName = '';
    let streetNumber = '';
    let cp = "";
    let province = "";
    let municipality = "";

    addressData.forEach((element: any) => {
      switch (element.types[0]) {
        case 'route':
          streetName = element.long_name;
          break;

        case 'street_number':
          streetNumber = element.long_name;
          break;

        case 'postal_code':
          cp = element.long_name;
          break;

        case 'administrative_area_level_2':
          province = element.long_name;
          break;

        case 'locality':
          municipality = element.long_name;
          break;
        
      }
    });

    const fullStreetName = `${streetName}, ${streetNumber}, ${province}, ${cp}`;
    this.setValueOnField('direccion', fullStreetName, form);

    const direccion = {
      via: fullStreetName,
      codigoPostal: cp,
      provincia: province,
      municipio: municipality
    };
    
    sessionStorage.setItem('direccion', JSON.stringify(direccion));
  }


  setValueOnField(field: string, value: string, form: FormGroup) {
    const control = form.get(field);
    if (control) {
      control.setValue(value);
    } else {
      console.warn(`El campo "${field}" no existe en el FormGroup`);
    }
  }

}
